// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import DateRangeController from './date_range_controller'
application.register('date-range', DateRangeController)

import HelloController from './hello_controller'
application.register('hello', HelloController)

import ConvertorStatusStimulusController from './convertor_status_stimulus_controller'
application.register(
  'convertor-status-stimulus',
  ConvertorStatusStimulusController,
)

import BusinessDashboardController from './business_dashboard_controller'
application.register('business-dashboard', BusinessDashboardController)

import BulkUploadController from './bulk_upload_controller'
application.register('bulk-upload', BulkUploadController)

import AuthFormController from './auth_form_controller'
application.register('auth-form', AuthFormController)

import LocationController from './location_controller'
application.register('location', LocationController)

import ToastController from './toast_controller'
application.register('toast', ToastController)


import AudienceFiltersController from "./audience_filters_controller"
application.register("audience-filters", AudienceFiltersController)

import TopUpController from "./top_up_controller"
application.register("top-up", TopUpController)

import TopUpConfirmationController from "./top_up_confirmation_controller"
application.register("top-up-confirmation", TopUpConfirmationController)

import ReferenceCopyController from "./reference_copy_controller"
application.register("reference-copy", ReferenceCopyController)
